const inbox = {
  statuses: {
    pending: "Pending",
    approved: "Approved",
    posted: "Published",
    archived: "Archived",
  },
  original: {
    title: "Original post",
    open: "Open",
    openOriginal: "Open original",
    mediaOnly: "This Telegram post contains media without a text caption.",
    attachmentAlt: "Telegram post attachment",
    summary: "Original content summary",
    characters_one: "{{formattedCount}} character",
    characters_other: "{{formattedCount}} characters",
    mediaAttached: "media attached",
  },
  preview: {
    title: "Telegram preview",
    empty: "Your curated Telegram message will appear here.",
    label: "Preview",
    source: "Source: @{{channel}}",
  },
  ai: {
    toolkit: "AI Curation Toolkit",
    generating: "Generating",
    description: "Powered by server-side AI. Use these review-only actions to edit posts using AI.",
    draftReady: "AI draft ready",
    suggestionDescription: "Review the {{action}} suggestion before applying it.",
    before: "Before",
    after: "After",
    dismiss: "Dismiss",
    apply: "Apply",
    actions: {
      rephrase: "Rephrase",
      summarize: "Summarize",
      translate: "Translate",
      hashtags: "Hashtags",
    },
    tone: "Tone",
    language: "Language",
    tones: {
      professional: "Professional",
      casual: "Casual",
      viral: "Punchy & Viral",
      news: "Insightful News",
      bullets: "Bullet Summary",
    },
    languages: {
      english: "English",
      spanish: "Spanish",
      russian: "Russian",
      french: "French",
      german: "German",
      chinese: "Chinese",
      arabic: "Arabic",
      persian: "Persian",
    },
  },
  editor: {
    title: "Curated version",
    unsaved: "Unsaved changes",
    saved: "Draft is saved",
    copied: "Copied",
    copy: "Copy",
    saveDraft: "Save draft",
  },
  feedback: {
    draftSaved: "Draft saved.",
    approved: "Post approved and moved to the approved queue.",
    approveBeforePublishing: "Approve this post before publishing.",
    destinationRequired: "Configure and enable a Telegram destination before publishing.",
    publishSuccess: "Published successfully to the selected Telegram destinations.",
    publishFailed: "Publishing failed. Review the destination error and try again.",
    aiCurationError: "AI could not process this post. Check the provider configuration and try again.",
    aiConnectionError: "Could not contact the configured AI provider. Please try again.",
    suggestionApplied: "AI suggestion applied. Save or approve when ready.",
  },
  destinations: {
    selected_one: "{{formattedCount}} destination selected",
    selected_other: "{{formattedCount}} destinations selected",
    noneEnabled: "No Telegram destinations enabled",
    publishingTo_one: "Publishing to {{formattedCount}} destination",
    publishingTo_other: "Publishing to {{formattedCount}} destinations",
    configureToPublish: "Configure a Telegram destination to publish",
  },
  actions: {
    approve: "Approve",
    publish: "Publish",
    publishing: "Publishing",
    archive: "Archive",
    restore: "Restore",
    sync: "Sync sources",
    syncing: "Syncing",
  },
  search: {
    label: "Search posts or channels",
    placeholder: "Search posts or channels",
  },
  empty: {
    title: "No {{status}} posts",
    search: "No posts match this search. Try another channel or phrase.",
    default: "Sync your source channels to collect fresh Telegram content.",
  },
  queue: {
    title: "Post queue",
    count: "{{formattedCount}} {{status}}",
    mediaPost: "Media post",
  },
  mobile: {
    reviewPost: "Review post",
    back: "Back to post list",
    position: "{{current}} of {{total}}",
    steps: {
      review: "Review",
      approve: "Approve",
      publish: "Publish",
    },
    modeLabel: "Review mode",
    modes: {
      original: "Original",
      edit: "Edit",
      preview: "Preview",
    },
  },
  accessibility: {
    originalPost: "Original post",
    postStatus: "Post status",
    toolkit: "AI Curation Toolkit",
    curatedVersion: "Curated version",
    postQueue: "Post queue",
    curatedEditor: "Curated post editor",
    mobilePostList: "Mobile post list",
    reviewPost: "Review post",
  },
} as const;

export default inbox;
